
    //------------------ stickyCTA ------------------//

    $('#enableSS').on('click', function (event) {
        $('.subscribe-box__default').trigger("click");
        $('#closeDisclaimer').trigger("click");
        //close ss-box
        agreeToSS(true);
    })

    //------------------ End stickyCTA ------------------//
